// 导入axios
import axios from "axios";

// 导入全局的状态管理
import store from "../store";
// 创建axios
const request = axios.create({
  // 配置接口的基准路径
  // baseURL: "http://127.0.0.1:3000/api",
});

// 拦截请求 请求的时候追加一个令牌
request.interceptors.request.use(
  (config) => {
    const { user } = store.state;
    // 如果有用户并且有token 就进行配置
    if (user && user.token) {
      config.headers.Authorization = `Bearer${user.token}`;
    }
    return config;
  },
  (error) => {
    // 如果请求出错了，还没有发送出去，就会到这里
    return Promise.reject(error);
  }
);

// 拦截响应，如果请求是404怎么处理 成功怎么返回
request.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      return response.data;
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 导出
export default request;
